import { createAction, props } from '@ngrx/store';
import { StaticStoreSource } from '../../domain/models/static-store-source.model';

export const getStaticStore = createAction(
  '[StaticStore] States',
  props<{ source: string }>()
);

export const getStaticStoreSuccess = createAction(
  '[StaticStore] States - Success',
  props<{ response: StaticStoreSource | null }>()
);
